import type { ExecutionStatus } from "@/types/execution.types";
import { API_BASE_URL, fetchWithTimeout, handleResponse } from "./shared";

// ============================================================================
// Execution Status API
// ============================================================================

export const executionStatusApi = {
  /**
   * Get execution system status
   */
  async getStatus(): Promise<ExecutionStatus> {
    const response = await fetchWithTimeout(`${API_BASE_URL}/api/v1/cqg/status`);
    return handleResponse<ExecutionStatus>(response);
  },
};
